import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {PagedListOfProcessingReport, PledgeType} from '../../../../../services/api.client';
import {Company} from '../../../../../services/api.client';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';

import {formatCurrency, formatDate} from '../../../../../utilities/Util';
import {PaymentProcessingFormComponent} from '../../../paymentprocessing/PaymentProcessingFormComponent';
import {User} from '../../../../../services/api.client';
import {SecurityService} from '../../../../../services/SecurityService';

@Component({
    selector: 'pledgesDetail',
    templateUrl: './PendingPledgesDetailComponent.html',
    styleUrls: ['./PendingPledgesDetailComponent.scss'],
    standalone: false
})

export class PendingPledgesDetailComponent implements OnInit {
    tableHeaders: ITableHeader[] = [];
    rows: any;

    @ViewChild('form')
    form: PaymentProcessingFormComponent;

    // subscription
    currentUser: User;
    currentUser$: Observable<User>;
    private readonly _report$ = new BehaviorSubject<PagedListOfProcessingReport>(null);
    report$: Observable<PagedListOfProcessingReport> = this._report$.asObservable();
    report: PagedListOfProcessingReport;

    constructor(private _securityService: SecurityService) {
        this.currentUser$ = this._securityService.currentUser$;
    }

    submitReport(): void {
        this.form.submitPendingPledgesDetail()?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }

    ngOnInit(): void {
        this.report$.subscribe(report => this.report = report);
        this.currentUser$.subscribe(user => this.currentUser = user);
        if (this.currentUser.hasPrivate) {
            this.tableHeaders = [
                {text: 'Status', sortKey: 'Status'},
                {text: 'Pledge #', sortKey: 'PledgeNumber'},
                {text: 'Pledge Type', sortKey: 'PledgeType'},
                {text: 'First Name', sortKey: 'FirstName'},
                {text: 'Last Name', sortKey: 'LastName'},
                {text: 'Company', sortKey: 'Company'},
                {text: 'Utility Acct#', sortKey: 'AccountNumber'},
                {text: 'Invoice #', sortKey: 'InvoiceNumber'},
                {text: 'Amount', sortKey: 'Amount'},
                {text: 'Agency', sortKey: 'Agency'},
                {text: 'Pledged Date', sortKey: 'PledgedDate'},
                {text: 'Crisis', sortKey: 'Crisis'},
                {text: 'Client SSN', sortKey: 'Last4Ssn'},
                {text: 'Paid Date', sortKey: 'PaidDate'},
                {text: 'Ledger #', sortKey: 'LedgerNumber'},
                {text: 'Private', sortKey: 'Private'},
                {text: 'Census Tract', sortKey: 'CensusTract'},
                {text: 'Address1', sortKey: 'Address1'},
                {text: 'Address2', sortKey: 'Address2'},
                {text: 'City', sortKey: 'City'},
                {text: 'State', sortKey: 'State'},
                {text: 'Zip Code', sortKey: 'ZipCode'},
                {text: 'Special Coding', sortKey: 'SpecialCoding'},
                {text: 'Entered By Name', sortKey: 'EnteredByName'},
                {text: 'Entered By Email', sortKey: 'EnteredByEmail'},
            ];

            this.rows = this.report$.pipe(
                filter(report => !!report),
                map((reports) => reports.items.map((report) => [
                    report.status,
                    report.pledgeNumber,
                    report.pledgeType,
                    report.firstName,
                    report.lastName,
                    report.company,
                    report.clientCompanyAccountNumber,
                    report.invoiceNumber,
                    formatCurrency(report.amount),
                    report.agency,
                    formatDate(report.pledgedDate),
                    report.crisis ? 'Yes' : 'No',
                    report.clientLast4Ssn,
                    formatDate(report.paidDate),
                    report.ledgerNumber,
                    report.isPrivate,
                    report.censusTract,
                    report.address1,
                    report.address2,
                    report.city,
                    report.state,
                    report.zipCode,
                    report.specialCoding,
                    report.enteredByName,
                    report.enteredByEmail
                ])));

        } else {
            this.tableHeaders = [
                {text: 'Status', sortKey: 'Status'},
                {text: 'Pledge #', sortKey: 'PledgeNumber'},
                {text: 'Pledge Type', sortKey: 'PledgeType'},
                {text: 'First Name', sortKey: 'FirstName'},
                {text: 'Last Name', sortKey: 'LastName'},
                {text: 'Company', sortKey: 'Company'},
                {text: 'Utility Acct#', sortKey: 'AccountNumber'},
                {text: 'Invoice #', sortKey: 'InvoiceNumber'},
                {text: 'Amount', sortKey: 'Amount'},
                {text: 'Agency', sortKey: 'Agency'},
                {text: 'Pledged Date', sortKey: 'PledgedDate'},
                {text: 'Crisis', sortKey: 'Crisis'},
                {text: 'Client SSN', sortKey: 'Last4Ssn'},
                {text: 'Paid Date', sortKey: 'PaidDate'},
                {text: 'Ledger #', sortKey: 'LedgerNumber'},
                {text: 'Census Tract', sortKey: 'CensusTract'},
                {text: 'Address1', sortKey: 'Address1'},
                {text: 'Address2', sortKey: 'Address2'},
                {text: 'City', sortKey: 'City'},
                {text: 'State', sortKey: 'State'},
                {text: 'Zip Code', sortKey: 'ZipCode'},
                {text: 'Special Coding', sortKey: 'SpecialCoding'},
                {text: 'Entered By Name', sortKey: 'EnteredByName'},
                {text: 'Entered By Email', sortKey: 'EnteredByEmail'},
            ];

            this.rows = this.report$.pipe(
                filter(report => !!report),
                map((reports) => reports.items.map((report) => [
                        report.status,
                        report.pledgeNumber,
                        report.pledgeType,
                        report.firstName,
                        report.lastName,
                        report.company,
                        report.clientCompanyAccountNumber,
                        report.invoiceNumber,
                        formatCurrency(report.amount),
                        report.agency,
                        formatDate(report.pledgedDate),
                        report.crisis ? 'Yes' : 'No',
                        report.clientLast4Ssn,
                        formatDate(report.paidDate),
                        report.ledgerNumber,
                    report.censusTract,
                    report.address1,
                    report.address2,
                    report.city,
                    report.state,
                    report.zipCode,
                    report.specialCoding,
                    report.enteredByName,
                    report.enteredByEmail
                    ])
                )
            );
        }
    }

    onTableUpdate(pagedList: PagedListOfProcessingReport): void {
        this.form.submitPendingPledgesDetail(pagedList.offset, pagedList.limit)
            ?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
    }
}
